// Canonical marketplace categories. Uploads pick from this fixed list (no free-text) so the
// marketplace filter stays clean and consistent instead of filling with one-off spellings.
// Add a category = one line here.
export const CATEGORIES = [
  "General",
  "Git & GitHub",
  "Data",
  "Testing",
  "Code Quality",
  "Documentation",
  "DevOps",
  "Backend",
  "Frontend",
  "Security",
  "Productivity",
  "Writing",
  "Config",
  "Automation",
];
